import TourProductsRepository from '@/js/common/Domain/Repository/TourProducts';
import abTests from '@/js/common/Domain/Service/abTests';
import groupProductsByCriterias from '@/js/common/Domain/Service/groupProductsByCriterias';

const getKey = (product) => {
    const nights = product.get('nights');
    const nightsInHotel = product.get('nightsInHotel') === undefined
        ? nights
        : product.get('nightsInHotel');

    const date = product.get('startDate');
    const meal = product.get('meal').get('id');
    const room = product.get('room');
    const operator = product.get('operator');
    const roomCategory = room.category || `${operator.id}_${room.name}`;

    return abTests.hasTest('IN-4507')
        ? `${nights}_${date}_${meal}_${roomCategory}`
        : `${nights}_${nightsInHotel}_${date}_${meal}_${roomCategory}`;
};

const findSimilarProducts = (product, groupedOffers) => {
    const productKey = getKey(product);

    return groupedOffers
        .filter(([offer]) => getKey(offer.get('product')) === productKey)
        .reduce((acc, offerGroup) => [...acc, ...offerGroup], []);
};

export default (tourProducts) => {
    if (!tourProducts?.length) return [];

    const groupedToursByHash = groupProductsByCriterias(tourProducts, 'TourProduct');
    const groupedHotelOffersByHash = groupProductsByCriterias(tourProducts, 'HotelOfferProduct');
    const groupedRailwaysByHash = groupProductsByCriterias(tourProducts, 'RailwayTourProduct');

    const groupedToursMapped = _.map(groupedToursByHash, (groupedByhashProducts) => {
            const [firstProduct, ...otherProducts] = groupedByhashProducts;
            const similarHotelOffers = findSimilarProducts(firstProduct.get('product'), groupedHotelOffersByHash);
            const similarRailwaysOffers = findSimilarProducts(firstProduct.get('product'), groupedRailwaysByHash);

            otherProducts.push(...similarHotelOffers, ...similarRailwaysOffers);

            firstProduct.set('similarProducts', otherProducts);

            return firstProduct;
        }
    );

    if (groupedToursByHash.length > 0) {
        return new TourProductsRepository(groupedToursMapped);
    } else if (groupedHotelOffersByHash.length > 0) {
        const hotelOffersMapped = _.map(groupedHotelOffersByHash, (hotelOffer) => {
            const [firstProduct, ...otherProducts] = hotelOffer;
    
            firstProduct.set('similarProducts', otherProducts);
    
            return firstProduct;
        })

        return new TourProductsRepository(hotelOffersMapped);
    } 

    const railwaysOffersMapped = _.map(groupedRailwaysByHash, (product) => {
        const [firstProduct, ...otherProducts] = product;

        firstProduct.set('similarProducts', otherProducts);

        return firstProduct;
    });

    return new TourProductsRepository(railwaysOffersMapped);
};
